import { CALL_API, Schemas } from '../../common/middleware/api';

export const DISCOUNTS_REQUEST = 'DISCOUNTS_REQUEST';
export const DISCOUNTS_SUCCESS = 'DISCOUNTS_SUCCESS';
export const DISCOUNTS_FAILURE = 'DISCOUNTS_FAILURE';

export const DISCOUNT_FETCH_REQUEST = 'DISCOUNT_GET_REQUEST';
export const DISCOUNT_FETCH_SUCCESS = 'DISCOUNT_GET_SUCCESS';
export const DISCOUNT_FETCH_FAILURE = 'DISCOUNT_GET_FAILURE';

export const DISCOUNT_CREATE_REQUEST = 'DISCOUNT_CREATE_REQUEST';
export const DISCOUNT_CREATE_SUCCESS = 'DISCOUNT_CREATE_SUCCESS';
export const DISCOUNT_CREATE_FAILURE = 'DISCOUNT_CREATE_FAILURE';

export const DISCOUNT_UPDATE_REQUEST = 'DISCOUNT_UPDATE_REQUEST';
export const DISCOUNT_UPDATE_SUCCESS = 'DISCOUNT_UPDATE_SUCCESS';
export const DISCOUNT_UPDATE_FAILURE = 'DISCOUNT_UPDATE_FAILURE';

export const DISCOUNT_USAGE_REQUEST = 'DISCOUNT_USAGE_REQUEST';
export const DISCOUNT_USAGE_SUCCESS = 'DISCOUNT_USAGE_SUCCESS';
export const DISCOUNT_USAGE_FAILURE = 'DISCOUNT_USAGE_FAILURE';

export const loadDiscounts = (options) => ({
	[CALL_API]: {
		types: [DISCOUNTS_REQUEST, DISCOUNTS_SUCCESS, DISCOUNTS_FAILURE],
		endpoint: 'api/discounts',
		request: options,
		schema: Schemas.DISCOUNT_ARRAY
	}
});

export const fetchDiscount = (id) => ({
	[CALL_API]: {
		types: [DISCOUNT_FETCH_REQUEST, DISCOUNT_FETCH_SUCCESS, DISCOUNT_FETCH_FAILURE],
		endpoint: `api/discounts/${id}`,
		schema: Schemas.DISCOUNT
	}
});

export const createDiscount = (discount, history) => ({
	[CALL_API]: {
		types: [DISCOUNT_CREATE_REQUEST, DISCOUNT_CREATE_SUCCESS, DISCOUNT_CREATE_FAILURE],
		endpoint: 'api/discounts',
		method: 'POST',
		request: discount,
		schema: Schemas.DISCOUNT,
		form: 'discount',
		transition: {
			history,
			successPath: (response) => {
				return `/discounts`;
			}
		}
	}
});

export const updateDiscount = (id, discount) => ({
	[CALL_API]: {
		types: [DISCOUNT_UPDATE_REQUEST, DISCOUNT_UPDATE_SUCCESS, DISCOUNT_UPDATE_FAILURE],
		endpoint: `api/discounts/${id}`,
		method: 'PUT',
		request: discount,
		schema: Schemas.DISCOUNT,
		form: 'discount'
	}
});

export const loadDiscountUsage = (id, options) => ({
	[CALL_API]: {
		types: [DISCOUNT_USAGE_REQUEST, DISCOUNT_USAGE_SUCCESS, DISCOUNT_USAGE_FAILURE],
		endpoint: `api/discounts/${id}/usage`,
		request: options,
		schema: Schemas.DISCOUNT_USAGE_ARRAY
	}
});